import { render, staticRenderFns } from "./myself.vue?vue&type=template&id=2998a3fc&scoped=true&"
import script from "./myself.vue?vue&type=script&lang=js&"
export * from "./myself.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998a3fc",
  null
  
)

export default component.exports